import PosthogService from '~/services/posthog/PosthogService';
import { OnsiteInterviewStatus } from '~/domain/PermanentJobs/enums/OnsiteInterviewStatus';

// Event-specific interface (co-located)
export interface IPermInterviewListFilterClickedPayload {
  postingId: string;
  filter: 'all' | OnsiteInterviewStatus;
}

/**
 * Fires when user clicks a filter option in the interview list
 * Event: dental_portal:perm_interview_list:filter_clicked
 */
export function firePermInterviewListFilterClicked(
  payload: IPermInterviewListFilterClickedPayload,
): void {
  // Map filter values to the required snake_case format from JIRA requirements
  let filterValue: string;
  switch (payload.filter) {
    case 'all':
      filterValue = 'all_active';
      break;
    case OnsiteInterviewStatus.ActionNeeded:
      filterValue = 'action_needed';
      break;
    case OnsiteInterviewStatus.Open:
      filterValue = 'open';
      break;
    case OnsiteInterviewStatus.Scheduled:
      filterValue = 'scheduled';
      break;
    case OnsiteInterviewStatus.Completed:
      filterValue = 'completed';
      break;
    case OnsiteInterviewStatus.Cancelled:
      filterValue = 'cancelled_and_expired';
      break;
    default:
      filterValue = payload.filter;
  }

  PosthogService.getInstance().track('dental_portal:perm_interview_list:filter_clicked', {
    posting_id: payload.postingId,
    filter: filterValue,
  });
}
